import { useBreakpoint } from '@app/hooks';
import { CatSkeleton } from '@blocks-react/components/Skeleton';
import { PAGE_BREAKPOINTS } from '@app/constants/commonConstants';
import style from './LargePaginationLoader.module.scss';

const LargePaginationLoader = () => {
  const isMD = useBreakpoint(PAGE_BREAKPOINTS.MD);
  const smallLoader = (
    <CatSkeleton
      className="cat-u-display-block cat-u-margin-top-md"
      size="sm"
    />
  );
  return (
    <div data-testid="tableLoader">
      <CatSkeleton size="xl" />
      {isMD ? (
        <div className="d-flex justify-content-between">
          <div className={style['side-loader-width']}>{smallLoader}</div>
          <div className={style['center-loader-width']}>{smallLoader}</div>
          <div className={style['side-loader-width']}>{smallLoader}</div>
        </div>
      ) : (
        <div>{smallLoader}</div>
      )}
    </div>
  );
};
export default LargePaginationLoader;
